<template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header">
    <div class="page-header-left">
      <h3 class="pr-3" style="font-weight: bold">{{title}}</h3>
    </div>
    <v-breadcrumbs divider="">
      <v-breadcrumbs-item v-for="(item,key) in breadcrumbs" :key="key">
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
    <div class="page-header-right onRefresh">
      <span class="onRefreshCircle">
        <v-progress-circular
          :size="30"
          :width="5"
          :rotate="180"
          :value="value"
          color="pink"
        >
        {{ value / 10 }}
        </v-progress-circular>
      </span>
      <v-btn icon @click="onRefresh">
        <v-icon class="text--secondary">refresh</v-icon>
      </v-btn>
    </div>
  </v-layout>  
</template>

<script>
import VWidget from '@/components/VWidget';
import menu from '@/api/menu';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      title: '',
      interval: {},
      value: 300
    };
  },
  computed: {
    breadcrumbs: function () {
      let breadcrumbs = [];
      menu.forEach(item => {
        if (item.items) {
          let child =  item.items.find(i => {
            return i.component === this.$route.name;
          });
          if (child) {
            breadcrumbs.push(item.title);
            breadcrumbs.push(child.title);
            this.title = child.title;
          }
        } else {
          if (item.name === this.$route.name) {
            this.title = item.title;
            breadcrumbs.push(item.title);
          }
        }
      });
      return breadcrumbs;
    }
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  methods: {
    chkAutoReload: function () {
      for (let i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].$el.className === 'mainView') {
          clearInterval(this.interval);
          this.$el.getElementsByClassName('onRefresh')[0].hidden = false;
          if (this.$parent.$children[i].autoReload === true) {
            this.$el.getElementsByClassName('onRefreshCircle')[0].hidden = false;
            this.interval = setInterval(() => {
              if (this.value === 0) {
                this.onRefresh();
                return;
              }
              this.value -= 10;
            }, 1000);
          } else {
            this.$el.getElementsByClassName('onRefreshCircle')[0].hidden = true;
            this.value = 100;
            clearInterval(this.interval);
          }
        }
        if (this.$parent.$children[i].$el.className === 'subView') {
          this.$el.getElementsByClassName('onRefresh')[0].hidden = true;
        }
      }
    },
    onRefresh: function () {
      this.value = 300;
      for (let i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].$el.className === 'mainView') {
          this.$parent.$children[i].banbanCreated();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PageHeader.vue